import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Helmet from '@/pages/home/components/Helmet';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '「妈妈的朋友们」是什么样的平台？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '「妈妈的朋友们」是一个温暖真实的情感故事平台，专注于分享妈妈与她身边朋友们的故事、羁绊与人生智慧。我们相信，母辈女性的友情之美和生活哲学值得被记录和传颂。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向「妈妈的朋友们」投稿？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们欢迎所有关于妈妈和她的朋友们的故事。你可以将你的故事发送到我们的邮箱 hello@momfriends.cn，或者通过网站底部的订阅表单联系我们。我们会在收到后尽快回复。',
      },
    },
    {
      '@type': 'Question',
      name: '「妈妈的朋友们」的文章都是真实故事吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，我们平台上的所有文章都来源于真实的读者投稿和采编故事。每一篇故事都经过细致的整理和编辑，力求还原最真实的情感和细节，让读者能够产生深切的情感共鸣。',
      },
    },
    {
      '@type': 'Question',
      name: '如何订阅「妈妈的朋友们」的故事更新？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '你可以在网站首页底部的订阅区域输入你的邮箱地址，我们将每周为你推送一篇精选的温暖故事。我们承诺不会滥用你的邮箱信息，你可以随时取消订阅。',
      },
    },
  ],
};

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '关于我们 - 妈妈的朋友们',
  description:
    '了解「妈妈的朋友们」的品牌故事与使命。我们致力于收集和分享妈妈与她朋友们之间的温暖故事，传递母辈女性的生活智慧与情感力量。',
  publisher: {
    '@type': 'Organization',
    name: '妈妈的朋友们',
  },
};

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Helmet
        title="关于我们 - 妈妈的朋友们 | 品牌故事与联系方式"
        description="了解「妈妈的朋友们」的品牌故事与使命。我们致力于收集和分享妈妈与她朋友们之间的温暖故事，传递母辈女性的生活智慧与情感力量。联系我们：hello@momfriends.cn"
        keywords="妈妈的朋友们关于我们,妈妈的故事平台介绍,关于妈妈的朋友们,联系我们"
        canonicalUrl="https://momfriends.cn/about"
        ogTitle="关于我们 - 妈妈的朋友们"
        ogDescription="了解「妈妈的朋友们」的品牌故事与使命。我们致力于收集和分享妈妈与她朋友们之间的温暖故事。"
      />
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <Navbar />
      <main className="min-h-screen pt-20">
        <div className="bg-background-50">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="w-full px-4 md:px-6 py-10 md:py-16">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-10 md:mb-14">
                <h1 className="font-heading text-3xl md:text-4xl text-foreground-950">
                  关于妈妈的朋友们
                </h1>
                <p className="mt-4 text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                  一个收集和分享母辈女性友情故事的温暖角落
                </p>
              </div>

              <div className="relative w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden mb-10 md:mb-14">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20gathering%20of%20Chinese%20elderly%20women%20in%20a%20cozy%20living%20room%2C%20sharing%20stories%20and%20laughing%20together%2C%20afternoon%20sunlight%20through%20curtains%2C%20family%20photos%20on%20wall%2C%20warm%20and%20intimate%20atmosphere%2C%20soft%20natural%20lighting%2C%20gentle%20bokeh%20effect%2C%20heartwarming%20scene%20of%20female%20friendship&width=1200&height=600&seq=about-hero&orientation=landscape"
                  alt="妈妈的朋友们 - 温馨聚会"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 pb-10 md:pb-16">
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                    我们的品牌故事
                  </h2>
                  <div className="space-y-4 text-base text-foreground-700 leading-relaxed">
                    <p>
                      「妈妈的朋友们」诞生于一个温暖的午后。创始人小月在整理妈妈的老相册时，发现了一张张泛黄的照片——妈妈和她的姐妹们年轻时的笑容，那些跨越了几十年的友情故事，让她深受触动。
                    </p>
                    <p>
                      她开始采访妈妈和妈妈的每一位朋友，记录下她们的故事。从青涩的少女时代，到为人妻为人母，再到白发苍苍的晚年。那些故事里有欢笑、有泪水、有争吵、有和解，但更多的是穿越岁月的深情厚谊。
                    </p>
                    <p>
                      小月把这些故事分享到了网上，没想到引发了无数人的共鸣。评论区里，读者们纷纷写下自己妈妈的故事。"原来我们的妈妈们，拥有这么精彩的人生"，"看到就想起了我妈妈和她的闺蜜"。这些留言让我们意识到——母辈女性的友情，是一个被忽视却无比珍贵的宝藏。
                    </p>
                    <p>
                      于是，「妈妈的朋友们」从一个人的记录，变成了一群人的分享。我们相信，每一位妈妈和她的朋友们，都值得被看见、被听见、被铭记。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                    我们的使命
                  </h2>
                  <div className="space-y-4 text-base text-foreground-700 leading-relaxed">
                    <p>
                      我们致力于成为华语世界最温暖的情感故事平台，专注于记录和分享母辈女性的友情故事与生活智慧。
                    </p>
                    <div className="space-y-3 mt-4">
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5">
                          <i className="ri-heart-line text-sm"></i>
                        </div>
                        <p className="text-sm">
                          <strong className="font-label text-foreground-950">记录真实故事：</strong>
                          每一篇故事都来自真实的投稿和采访，拒绝虚构和煽情，用最质朴的文字传递最真挚的情感。
                        </p>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5">
                          <i className="ri-lightbulb-line text-sm"></i>
                        </div>
                        <p className="text-sm">
                          <strong className="font-label text-foreground-950">传递生活智慧：</strong>
                          妈妈们用半生积累的生活哲学，关于家庭、友情、爱与成长，都是无价的精神财富。
                        </p>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5">
                          <i className="ri-group-line text-sm"></i>
                        </div>
                        <p className="text-sm">
                          <strong className="font-label text-foreground-950">连接情感共鸣：</strong>
                          为每一个被故事触动的心灵提供一个温暖的角落，让更多人在这里找到共鸣与慰藉。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950 text-center mb-6">
                读者口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                <div className="p-5 bg-background-50 rounded-lg">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "每次读妈妈的朋友们的文章都会忍不住流泪。那些故事让我想起了我的妈妈和她的老姐妹们，她们之间那种默契和温暖，是世界上最珍贵的东西。"
                  </p>
                  <p className="text-xs text-foreground-500 font-label">— 读者 李女士, 35岁</p>
                </div>
                <div className="p-5 bg-background-50 rounded-lg">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "我把网站推荐给了妈妈，她现在每周都要看。她说这里的故事让她觉得不孤单，原来有这么多人和她一样，有着一群一辈子都分不开的老姐妹。"
                  </p>
                  <p className="text-xs text-foreground-500 font-label">— 读者 王先生, 28岁</p>
                </div>
                <div className="p-5 bg-background-50 rounded-lg">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "无意间发现了这个网站，一口气看了十几篇文章。每一篇都写到了心坎里。原来妈妈们的世界这么丰富，这么动人。这是一个有温度的角落。"
                  </p>
                  <p className="text-xs text-foreground-500 font-label">— 读者 张小姐, 30岁</p>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-16">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950 text-center mb-8">
                常见问题
              </h2>
              <div className="space-y-4 max-w-2xl mx-auto">
                {faqJsonLd.mainEntity.map((item, index) => (
                  <details
                    key={index}
                    className="group bg-background-100 rounded-lg p-4 md:p-5 cursor-pointer"
                  >
                    <summary className="font-label text-sm text-foreground-950 list-none flex items-center justify-between">
                      {item.name}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                      {item.acceptedAnswer.text}
                    </p>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-100">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
                如果你有妈妈和她朋友们的故事想要分享，或者有任何建议和想法，欢迎联系我們。每一封邮件我们都会认真阅读和回复。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="mailto:hello@momfriends.cn"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-label text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-line"></i>
                  hello@momfriends.cn
                </a>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-map-pin-line text-foreground-500"></i>
                  <span>北京市朝阳区</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}